import React, { useState, useRef, useEffect } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { PERMISSIONS } from "constants/permission";
import { UsePermissionVerification } from "components/customHooks";
import { MEDIA_TYPE_INDEX } from "constants/global";
import {
  MediaManagerWrapper,
  MediaMangerDialogTitle,
} from "./MediaManager.style";

import MediaUpload from "./MediaUpload";
import MediaSearch from "./MediaSearch";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MediaManager = (props) => {
  const [value, setValue] = useState("1");
  const [open, setOpen] = useState(false);
  const onSelectRef = useRef(null);
  const targetTypeRef = useRef(null);

  const AccessControl = UsePermissionVerification();

  useEffect(() => {
    AccessControl.SetAccess({
      ...AccessControl.Access,
      listMediaAccess: AccessControl.VerifyAccess([
        PERMISSIONS.RESOURCE.RESOURCE_LIST,
      ]),
      addMediaAccess: AccessControl.VerifyAccess([
        PERMISSIONS.RESOURCE.RESOURCE_ADD,
      ]),
      editMediaAccess: AccessControl.VerifyAccess([
        PERMISSIONS.RESOURCE.RESOURCE_EDIT,
      ]),
      archiveMediaAccess: AccessControl.VerifyAccess([
        PERMISSIONS.RESOURCE.RESOURCE_ARCHIVE,
      ]),
      searchMediaAccess: AccessControl.VerifyAccess([
        PERMISSIONS.RESOURCE.RESOURCE_QUERY_SEARCH,
      ]),
      queryMediaAccess: AccessControl.VerifyAccess([
        PERMISSIONS.RESOURCE.RESOURCE_QUERY,
      ]),
      queryByIdMediaAccess: AccessControl.VerifyAccess([
        PERMISSIONS.RESOURCE.RESOURCE_QUERY_BY_ID,
      ]),
    });
  }, [AccessControl.UserPermissions]);

  const normalizeTargetType = (targetType) => {
    const toIndex = (val) => {
      if (val === null || val === undefined) return null;
      if (typeof val === "number" && Number.isFinite(val)) return val;
      if (typeof val === "string") {
        const trimmed = val.trim();
        // numeric string like "3"
        if (/^\d+$/.test(trimmed)) return parseInt(trimmed, 10);
        // named type like "image", "video", etc.
        const lower = trimmed.toLowerCase();
        if (Object.prototype.hasOwnProperty.call(MEDIA_TYPE_INDEX, lower)) {
          return MEDIA_TYPE_INDEX[lower];
        }
      }
      return null;
    };
    if (!targetType) return [];
    if (Array.isArray(targetType)) {
      return targetType.map(toIndex).filter((x) => typeof x === "number");
    }
    const single = toIndex(targetType);
    return typeof single === "number" ? [single] : [];
  };

  const openMediaManager = (onSelect, targetType, initSearchType) => {
    onSelectRef.current = onSelect;
    targetTypeRef.current = normalizeTargetType(targetType);
    setOpen(true);
    if (initSearchType) {
      //
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const content = (
    <Dialog
      fullWidth
      maxWidth={false}
      open={open}
      TransitionComponent={Transition}
    >
      <MediaMangerDialogTitle>
        Media Manager
        <CloseIcon
          className="close-button"
          role="button"
          onClick={handleClose}
        />
      </MediaMangerDialogTitle>
      <DialogContent>
        <MediaManagerWrapper>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                {AccessControl.Access.searchMediaAccess && (
                  <Tab label="Search Media" value="1" />
                )}
                {AccessControl.Access.addMediaAccess && (
                  <Tab label="Upload Media" value="2" />
                )}
              </TabList>
            </Box>
            {AccessControl.Access.searchMediaAccess && (
              <TabPanel value="1">
                <MediaSearch
                  access={AccessControl.Access}
                  onSelect={onSelectRef.current}
                  handleClose={handleClose}
                  targetType={targetTypeRef.current}
                />
              </TabPanel>
            )}
            {AccessControl.Access.addMediaAccess && (
              <TabPanel value="2">
                <MediaUpload onSelect={onSelectRef.current} handleClose={handleClose} />
              </TabPanel>
            )}
          </TabContext>
        </MediaManagerWrapper>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );

  return [openMediaManager, content];
};

export default MediaManager;
